import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EngineeringPrecisionForIndustrialProgress from "./sections/EngineeringPrecisionForIndustrialProgress";
import About from "./sections/About";
import IntegratedBrandingSolutions from "./sections/IntegratedBrandingSolutions";
import OportunidadesEnRecambios from "./sections/OportunidadesEnRecambios";
import Footer from "@/reusable_sections/Footer";
import InsuranceCarriers from "./sections/InsuranceCarriers";
export default function HomePage() {
  return <div>
      <Header />
      <EngineeringPrecisionForIndustrialProgress />
      <About />
      <InsuranceCarriers />
      <IntegratedBrandingSolutions />
      <OportunidadesEnRecambios />
      <Footer />
    </div>;
}